export const SEARCH_KEYS = {
  ACTIVITY_SEARCH: 'activitySearch',
  // PaymentsTable has no search field; its own key keeps it off statement search.
  PAYMENTS_SEARCH: 'paymentsSearch',
  PAYOUT_SEARCH: 'payoutSearch',
  // Royalties list search. ANZ and World must not share a param —
  // navigating between the two regions would otherwise carry the search term
  // across and both pages would fight over one key.
  ROYALTIES_ANZ_EARNINGS_SEARCH: 'royaltiesAnzEarningsSearch',
  ROYALTIES_ANZ_TITLE_SEARCH: 'royaltiesAnzTitleSearch',
  ROYALTIES_WORLD_EARNINGS_SEARCH: 'royaltiesWorldEarningsSearch',
  ROYALTIES_WORLD_TITLE_SEARCH: 'royaltiesWorldTitleSearch',
  STATEMENT_SEARCH: 'statementSearch',
  TASKS_SEARCH: 'tasksSearch',
  // Titles L1 filters (APP-2156). Kept beside `TITLES_SEARCH` so both
  // implementations of the titles list key the same URL params from one place.
  TITLES_CLIENT: 'titlesClient',
  TITLES_SEARCH: 'titlesSearch',
  TITLES_SERVICE: 'titlesService',
  TITLES_STATUS: 'titlesStatus',
  TITLES_TYPE: 'titlesType',
  TITLES_YEAR: 'titlesYear',
};
